
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"<NONE>":"Absoluter Wert","<GRAND_TOTAL>":"Prozentsatz des Gesamtwerts ","<ROW_TOTAL>":"Prozentsatz des Zeilen-Gesamtwerts"},"en":{"<NONE>":"Absolute value","<GRAND_TOTAL>":"Percentage of grand total","<ROW_TOTAL>":"Percentage of row total"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();